<template>
  <component :is="tag">
    {{ roleName }}
  </component>
</template>

<script>

import roles from '~/roles'

export default {
  name: 'RoleName',
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    role: {
      type: String,
      required: true
    }
  },
  computed: {
    roleName () {
      const role = roles.find(r => r.role === this.role)
      return role ? role.name : 'UNKNOWN_ROLE'
    }
  }
}
</script>

<style scoped>

</style>
